<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

jQuery("button.docapp-add-to-cart").hover(function(){ 
        window.location.reload();
    
})


  
// var countDownDate = new Date("Jul 31, 2024 23:59:59").getTime();
 
// var x = setInterval(function() {

//   // Get today's date and time
//   var now = new Date().getTime();
     
//   var distance = countDownDate - now;
     
//   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//   var seconds = Math.floor((distance % (1000 * 60)) / 1000);
     
//   document.getElementById("offerTimer").innerHTML = "<span>" + days + " Days</span> <span>" + hours + " Hrs </span><span>" + minutes + " Mins </span><span>" + seconds + " Secs </span>";
     
//   if (distance < 0) {
//     clearInterval(x);
//     document.getElementById("offerTimer").innerHTML = "EXPIRED";
//   }
// }, 1000);


jQuery(document).ready(function($) {
    $('img').each(function() {
        var altText = $(this).attr('alt');
        
        // Check if the image is a product image
        if (!$(this).closest('.product').length) { 
            // Change alt tag only if it's not a product image
            $(this).attr('alt', 'Hi9');
        }
    });
});

